module.exports = __webpack_public_path__ + "img/poster (12).e6f9b9b9.jpg";